import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ComparisonProduct, ComparisonService } from '../../service/sage/comparison.service';
import { FranchiseService } from '../../service/franchise.service';

@Component({
  selector: 'app-comparison-bar',
  templateUrl: './comparison-bar.component.html',
  styleUrls: ['./comparison-bar.component.scss']
})
export class ComparisonBarComponent implements OnInit, OnDestroy {
  items: ComparisonProduct[] = [];
  visible = false;
  collapsed = false;
  private sub: Subscription = new Subscription();

  constructor(
    public comparisonService: ComparisonService,
    private router: Router,
    private franchiseService: FranchiseService
  ) {}

  ngOnInit() {
    this.sub.add(
      this.comparisonService.items$.subscribe(items => {
        this.items = items;
        // Auto-show bar when items are added
        if (items.length > 0) { this.collapsed = false; }
        // Auto-hide when all removed
        if (items.length === 0) { this.collapsed = false; }
      })
    );
    this.sub.add(
      this.comparisonService.barVisible$.subscribe(v => {
        this.visible = v;
        if (v) { this.collapsed = false; }
      })
    );
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  getThumb(item: ComparisonProduct): string {
    if (item.productData) {
      return item.productData.ThumbPicLink || item.productData.DefaultMediaPath || item.productData.thumbPicLink || '';
    }
    return '';
  }

  getName(item: ComparisonProduct): string {
    if (item.productData) {
      return item.productData.PrName || item.productData.Name || item.productId;
    }
    return item.productId;
  }

  remove(productId: string) {
    this.comparisonService.remove(productId);
  }

  compare() {
    const ids = this.items.map(p => p.productId).join(',');
    const sources = this.items.map(p => p.productSource).join(',');
    const franchiseData: any = this.franchiseService.franchiseData.getValue();
    const franchiseId = franchiseData && franchiseData['id'] ? franchiseData['id'] : '';
    this.router.navigate(['/' + franchiseId + '/promotional/product-comparison'], { queryParams: { ids, sources } });
  }

  clearAll() {
    this.comparisonService.clear();
  }

  collapse() {
    this.collapsed = true;
  }

  expand() {
    this.collapsed = false;
  }
}

